module.exports = __webpack_public_path__ + "img/fmicon.bb1b126f.svg";